import { styled } from '@linaria/react'

import type { FlexProps, SeparatorProps } from './types'

export const Flex = styled.div<FlexProps>`
  display: flex;
  justify-content: ${(props): string => props.justifyContent || 'unset'};
  gap: ${(props): string => props.gap || 'unset'};
  margin: ${(props): string => props.margin || '0'};
  align-items: ${(props): string => props.alignItems || 'unset'};
`

export const FlexRow = styled(Flex)`
  flex-direction: row;
`

export const FlexColumn = styled(Flex)`
  flex-direction: column;
`

export const Separator = styled.div<SeparatorProps>`
  border-bottom: ${(props): string => props.height || '1px'}
    ${(props): string => props.type || 'solid'}
    ${(props): string => props.color || 'var(--gray100)'};
  width: ${(props): string => (props.fullWidth ? '100vw' : '100%')};
  margin: ${(props): string => props.margin || '0'};
  margin-left: ${(props): string => (props.fullWidth ? '-24px' : '0')};
`
